import { Card, Form, Input, Button } from 'antd'
import { useEffect } from 'react'
import { SearchOutlined, ReloadOutlined } from "@ant-design/icons";
import AuthComponent from "../../../components/AuthComponent";
/**
 * 
 * @param {String} name 组件名
 * @param {Array} fields 表单搜索数据
 * @param {Object} initialValues 表单搜索数据
 * @param {Function} onSearch 提交方法
 * @param {Object} authKey 权限
 * @returns 
 */

const QueryFormComponent = (props) => {
  const {
    name,
    render,
    fields = [],
    initialValues = {},
    defaultValue = {},
    onSearch = () => { },
    reset = null,
    authKey = { search: "", export: "" },
    batchAdd = () => { },
    haveBatchAdd = false,
    batchReduce = () => { },
    haveBatchReduce = false
  } = props
  const [form] = Form.useForm()

  // 表单默认值配置
  useEffect(() => {
    form.setFieldsValue(defaultValue)
  }, [defaultValue])

  // 重置表单
  const onReset = () => {
    if (reset) reset()
    form.resetFields()
  }

  return (
    !!fields.length && (
      <Card style={{ marginBottom: '15px' }}>
        <Form
          name={name}
          layout="inline"
          form={form}
          initialValues={initialValues}
          onFinish={(formValue) => {
            onSearch({ ...formValue, pageIndex: 1 })
          }}
        >
          {fields.map(item => (
            <Form.Item
              label={item.label}
              name={item.name}
              key={item.name}
              style={{ marginBottom: '16px' }}
            >
              {item.component ? (item.component) : (
                <Input
                  allowClear
                  style={{ width: item.width ? item.width : '200px' }}
                  placeholder={item.placeholder || '请输入内容'}
                />
              )}
            </Form.Item>
          ))}
          <AuthComponent authKey={authKey.search}>
            <Form.Item>
              <Button
                ghost
                type="primary"
                htmlType="submit"
                icon={<SearchOutlined />}
              >
                搜索
              </Button>
            </Form.Item>
          </AuthComponent>
          <Form.Item>
            <Button
              ghost
              type="primary"
              icon={<ReloadOutlined />}
              onClick={onReset}
            >
              重置
            </Button>
          </Form.Item>
          {haveBatchAdd && <AuthComponent authKey='/mallZoneProduct/import'>
            <Form.Item>
              <Button
                ghost
                type="primary"
                onClick={batchAdd}
              >
                批量新增
              </Button>
            </Form.Item>
          </AuthComponent>}
          {haveBatchReduce && <AuthComponent authKey='/mallZoneProduct/batchDelete'>
            <Form.Item>
              <Button
                ghost
                type="primary"
                onClick={batchReduce}
              >
                批量移除
              </Button>
            </Form.Item>
          </AuthComponent>}
        </Form>
      </Card>
    )
  )
}

export default QueryFormComponent